import Vue from "vue";
import Router from "vue-router";
import NProgress from 'nprogress'
import store from '@/store/index'
import 'nprogress/nprogress.css'

const _import = require('./_import')
const layout = _import('Layout/Layout');

import {
	Routers
} from './routers'
import {
	GetToken
} from '@/utils'
Vue.use(Router);

let basicRouters = [{
		path: '/',
		component: layout,
		redirect: "/Home",
		children: [{
				path: '/Home',
				component: _import('Layout/Home'),
				name: 'Home',
				single: true,
				meta: {
					title: "概况",
					icon: "home"
				}
			},
			{
				path: '/buss/examinee',
				name: 'examinee',
				component: _import("Examination/examinee"),
				meta: {
					title: "排期考生",
					icon: "info"
				},
			},
			{ path: '/buss/examinee2/:roomItemId', component: _import('Examination/examinee'), meta: { title: '排期考生(NOTAB)', isTab:false}, hidden: true },
			{
				path: '/buss/examineeAdd',
				name: 'examineeAdd',
				component: _import("Examination/examineeAdd"),
				meta: {
					title: "排期添加考生",
					icon: "info"
				},
			},
			{ path: '/buss/examineeAdd2/:roomItemId', component: _import('Examination/examineeAdd'), meta: { title: '排期添加考生(NOTAB)', isTab:false}, hidden: true },
			// 报名管理
			{
				path: '/sign/upadd',
				name: 'upadd',
				component: _import("Examination/examineeUpdate"),
				meta: {
					title: "修改考生信息",
					icon: "info"
				},
			},
			// 后台管理报名
			{
				path: '/sign/upinfo',
				name: 'upinfo',
				component: _import("Examination/signUpAdd"),
				meta: {
					title: "考生报名",
					icon: "info"
				},
			},
			// 下载任务明细
			{
				path: '/download/dw_items',
				name: 'dw_items',
				component: _import("Examination/downLoadItems"),
				meta: {
					title: "下载任务明细",
					icon: "info"
				},
			},
			// 艺术节课程场次明细
			{
				path: '/Art/atCourseSession',
				name: 'art_atcoursesession',
				component: _import("Art/atCourseSession"),
				meta: {
					title: "艺术节课程场次明细",
					icon: "info"
				},
			},
			// 艺术节比赛排期明细
			{
				path: '/Art/atRoomItem',
				name: 'art_atroomitem',
				component: _import("Art/atRoomItem"),
				meta: {
					title: "艺术节比赛排期明细",
					icon: "info"
				},
			},
			// 艺术节比赛排期明细-获取未可选选手明细
			{
				path: '/Art/atRoomItemAdd',
				name: 'art_atroomitemadd',
				component: _import("Art/atRoomItemAdd"),
				meta: {
					title: "比赛候选人员列表",
					icon: "info"
				},
			}

		]
	},
	{
		path: '/Login',
		hidden: true,
		component: _import('Login/Index'),
		name: 'Login',
		meta: {
			title: "登录"
		}
	},
]

const router = new Router({
	routes: basicRouters
});
const whitelist = ['/Login']
router.beforeEach((to, from, next) => {
	NProgress.start();
	if (GetToken()) {
		NProgress.done()

		if (!store.getters.permissionRouter.length) {
			store.dispatch("GetPermissionRouter").then((routers) => {

				//动态挂载路由，否则会找不到对应路由
				router.addRoutes(routers)
				//动态挂载不会将路由添加到router中，需要手动添加
				router.options.routes = []
				routers = [...basicRouters, ...routers]
				routers.forEach(item => {
					let inx = router.options.routes.findIndex(it => it.path == item.path);
					if (inx === -1) {
						router.options.routes.push(item)
					}
				})
				next({
					...to,
					replace: true
				})
			})

		} else {
			next()
		}
	} else {
		if (whitelist.includes(to.path)) {
			NProgress.done()
			next()
		} else {
			NProgress.done()
			next('/Login')
		}
	}
})
export default router;
